import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.openExternalLinksInNewTab()
    this.hideFlashMessages()
    this.setMainContentMinHeight()
  }

  openExternalLinksInNewTab() {
    this.element.querySelectorAll("a").forEach((link) => {
      if (link.hostname && link.hostname !== window.location.hostname) {
        link.rel = "noopener"
        link.target = "_blank"
      }
    })
  }

  hideFlashMessages() {
    window.setTimeout(() => {
      this.element.querySelectorAll(".alerts .alert.to_hide").forEach((alert) => {
        alert.style.display = "none"
      })
    }, 5000)
  }

  setMainContentMinHeight() {
    const mainContent = this.element.querySelector(".container-fluid")

    if (mainContent) {
      mainContent.style.minHeight = `${window.innerHeight - 230}px`
    }
  }
}
